import {
  useFormSelector,
  FormPanel,
  FormCustomField,
  TextField,
  Form,
} from '@eas/common-web';

import React from 'react';

import { LocationPanel } from '../../../components/form/location-panel/location-panel';

import { ProcessForm } from '../minimal-distances-new-types';
import { StepLocationForm } from './step-location-types';
import { AddressField } from '../../../components/form/address-field/address-field';

import { HelpLabel } from '../../../components/help/help-label';
import { noop } from 'lodash';
import { formatFacilityCoordinates } from '../../minimal-distances/minimal-distances-fields';

export function StepLocationContent({
  allValues,
}: {
  allValues?: ProcessForm;
}) {
  const { lat: ovzLat, lon: ovzLon } = formatFacilityCoordinates(
    allValues?.ovzFacility
  );

  const { wgs84Coordinates } = useFormSelector((data: StepLocationForm) => ({
    wgs84Coordinates: data.wgs84Coordinates,
  }));

  return (
    <>
      <FormPanel label="Adresa zdroje - provozovna OVZ" defaultExpanded={true}>
        <Form editing={false} onSubmit={noop} initialValues={allValues}>
          <AddressField name="ovzFacility.address" disabled={true} />
        </Form>
        <FormCustomField
          label={
            <HelpLabel
              label="Zeměpisná šířka provozovny"
              code="LOCATION_LATITUDE"
            />
          }
        >
          <TextField value={ovzLat} onChange={noop} disabled={true} />
        </FormCustomField>
        <FormCustomField
          label={
            <HelpLabel
              label="Zeměpisná délka provozovny"
              code="LOCATION_LONGITUDE"
            />
          }
        >
          <TextField value={ovzLon} onChange={noop} disabled={true} />
        </FormCustomField>
      </FormPanel>
      <LocationPanel
        locationName="wgs84Coordinates"
        locationValue={wgs84Coordinates}
        addressPanelLabel="Souřadnice zdroje"
        locationPanelLabel="Poloha zdroje"
        showCoordinates={true}
        showMap={true}
        showAddress={false}
        showLocationPanel={true}
        showCoordinatesDistance={false}
        locationToolbarProps={{
          showFillAddressBtn: false,
          showFillMapBtn: false,
        }}
        defaultExpanded={true}
      />
    </>
  );
}
